import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Meta } from '@df/core/meta/meta';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class OnInteractionService {
    /**
     * If any intraection with document was set
     */
    readonly anyInteraction = new BehaviorSubject<boolean>(false);

    /**
     * If scroll intraection with document was set
     */
    readonly scrollOnCurrentInteraction = new BehaviorSubject<boolean>(false);

    constructor(@Inject(DOCUMENT) private document: Document, private meta: Meta) {
        this.setAnyEvents();
        this.setScrollCurrentEvents();
    }

    /**
     * Set events for any interactiom
     */
    private setAnyEvents() {
        this.setEvents(['click', 'touchstart', 'scroll', 'touchmove', 'wheel'], this.anyInteraction);
    }

    /**
     * Set events for scroll interaction
     */
    private setScrollCurrentEvents() {
        this.setEvents(['scroll', 'touchmove'], this.scrollOnCurrentInteraction);
        this.meta.subscribe(event => {
            if (this.scrollOnCurrentInteraction.value) {
                this.scrollOnCurrentInteraction.next(false);
                this.setEvents(['scroll', 'touchmove'], this.scrollOnCurrentInteraction);
            }
        });
    }

    private setEvents(eventNames: string[], subject: BehaviorSubject<boolean>) {
        // do nothing if value is set
        if (subject.value) {
            return;
        }
        const cb = () => {
            subject.next(true);
            eventNames.forEach(i => this.document.removeEventListener(i, cb));
        };
        eventNames.forEach(i => this.document.addEventListener(i, cb, { passive: true }));
    }
}
